export const api = {
  inplayAll: '/feedapi/?key=inplay-all',
  banners: '/config/banners',
  cashout: '/cashout',
  createRule: '/cashout/rule',
}
